var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"py-3 bg-secondary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tx-18 text-white"},[_vm._v(_vm._s(_vm.comp.task))])])])}
var staticRenderFns = []

export { render, staticRenderFns }